export default {
    title: "O-I",
    support: "Support",
    dashboard: "Dashboard"
}